module.exports = __webpack_public_path__ + "img/file-psd.bfae64e6.svg";